// import React, { useEffect, useState } from "react";

// import { useCustomDispatch, useCustomLocation } from "../../hooks";

// import {
// 	handleFormPatientNoteChange,
// 	handleRecurrenceChange,
// } from "../../utils/data/handleFormDataChange";

// import { hidePatientNoteModal } from "../../assets/js/custome";
// import { ModalCloseIcon } from "../../assets/svg/icons";
// import { useCustomPatientSelectors } from "../../services/selectors/patientSelectors";
// import { customStyles } from "../../style";

// import { PatientList } from "../../components/pharmacy/form/form";
// import { fetchPatientNotesList } from "../../services/actions/patients/patientNotesList";
// import { savePatientNotes } from "../../services/actions/patients/savePatientNote";
// import { submitPatientNote } from "../../utils/validations/others";

// import Select from "react-select";

// import * as initial from "../../utils/constants/formInitialStates";

// const AddNotes = ({
// 	setShowModal,
// 	showModal,
// 	patientProfileData,
// 	paginationNumber,
// 	showToast,
// 	setShowToast,
// 	queryStatus,
// 	querySearch,
// 	type,
// }) => {
// 	const dispatch = useCustomDispatch();
// 	const location = useCustomLocation();

// 	const {
// 		savePatientListResponse,
// 		patientListNotesData,
// 		patientListNotesResponse,
// 	} = useCustomPatientSelectors();

// 	const [patientNotesData, setPatientNoteData] = useState([]);
// 	const [selectedNoteOptions, setSelectedNoteOptions] = useState([]);
// 	const [color, setColor] = useState('#FFFFFF')

// 	const [notesData, setNotesData] = useState(initial.initalPatientNotes);
// 	const [formData, setFormData] = useState(initial.initalTopHeaderAddNoteData);

// 	const [errorMessages, setErrorMessages] = useState(
// 		initial.initalTopHeaderAddNoteData
// 	);

// 	const handleSelectChange = (selectedValues) => {
// 		setSelectedNoteOptions(selectedValues);
// 		setNotesData({
// 			...notesData,
// 			notes: selectedValues.data,
// 			selectedNoteOptions: selectedValues?.label,
// 		});
// 	};

// 	useEffect(() => {
// 		const notesData = patientListNotesData;
// 		const formattedNotesData = notesData?.map((value, index) => ({
// 			label: value.selectednoteoption,
// 			value: index,
// 			data: value.notes,
// 		}));

// 		setPatientNoteData(formattedNotesData);
// 	}, [patientListNotesData]);

// 	const handlePetientNotesList = () => {
// 		if (patientListNotesResponse?.data === null) {
// 			dispatch(fetchPatientNotesList());
// 		}
// 	};

// 	const handleColorChange = (event) => {
// 		setColor(event.target.value);
// 	};

// 	return (
// 		<>
// 			<div
// 				className="overflow-y-auto overflow-x-hidden fixed top-0 left-0 right-0 bottom-0 z-50 flex  items-center 
// 							justify-center w-full bg-black bg-opacity-50 dark:bg-opacity-100 max-h-full"
// 			>
// 				<div className="relative p-4 w-full max-w-2xl max-h-full">
// 					<div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
// 						<div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
// 							<h3 className="text-xl font-semibold text-gray-900 dark:text-white">
// 								Patient Notes
// 							</h3>
// 							<button
// 								onClick={() => hidePatientNoteModal(setShowModal, showModal)}
// 								type="button"
// 								className="close_btn bg-tableHeader text-white rounded-full 
// 								text-sm w-6 h-6 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
// 							>
// 								<ModalCloseIcon />
// 								<span className="sr-only">Close modal</span>
// 							</button>
// 						</div>

// 						{type === "Header_Add_Note" && (
// 							<div className="pt-4 md:pl-5 md:pr-5 relative z-20">
// 								<PatientList
// 									formData={formData}
// 									setFormData={setFormData}
// 									errorMessages={errorMessages}
// 									setErrorMessages={setErrorMessages}

// 								/>
// 							</div>
// 						)}

// 						<div className="md:p-5 space-y-4 ot_addNoteText z-10 relative">
// 							<div
// 								className="relative did-floating-label-content"
// 								onClick={handlePetientNotesList}
// 							>
// 								<Select
// 									isClearable={false}
// 									options={patientNotesData}
// 									isSearchable
// 									value={selectedNoteOptions}
// 									onChange={handleSelectChange}
// 									className="basic-multi-select z-20 "
// 									classNamePrefix="react-select"
// 									styles={customStyles}
// 									placeholder="Select From Note Option"
// 									noOptionsMessage={() =>
// 										patientListNotesResponse?.loading
// 											? "Loading..."
// 											: "No options"
// 									}
// 								/>
// 							</div>

// 							<div className="did-floating-label-content">
// 								<label
// 									htmlFor="Phn"
// 									className="ml-2  absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform 
// 												-translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 
// 												peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
// 												peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
// 								>
// 									Notes
// 								</label>

// 								<div
// 									id="cancellationNotesContainer"
// 									className="form-group full"
// 								>
// 									<textarea
// 										onChange={(e) =>
// 											handleFormPatientNoteChange(e, setNotesData, notesData)
// 										}
// 										value={notesData.notes}
// 										name="notes"
// 										className="fs-18 rubik-400 border border-gray-300 text-gray-900 rounded"
// 										id="cancellationNotes"
// 									></textarea>
// 								</div>
// 							</div>

// 							<div className="flex items-center mb-4">
// 								<input
// 									id="default-checkbox"
// 									type="checkbox"
// 									onChange={(e) =>
// 										handleRecurrenceChange(e, setNotesData, notesData)
// 									}
// 									value={notesData.recurrence}
// 									className="mr-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-transparent dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
// 								/>
// 								<label
// 									htmlFor="default-checkbox"
// 									className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
// 								>
// 									Recurrence
// 								</label>

// 								<label className="ml-2">
// 									<input
// 										type="color"
// 										value={color}
// 										onChange={handleColorChange}
// 										className="rounded bg-transparent"
// 									/>
// 								</label>

// 							</div>

// 							{notesData?.recurrence === 1 && (
// 								<div className="mb-2 sm:mb-4 md:mb-6 lg:mb-6 col-span-12 sm:col-span-12 md:col-span-4 lg:col-span-6">
// 									<div className="relative">
// 										<input
// 											type="text"
// 											id="remind"
// 											className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent h-[42px] 
// 														rounded border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 
// 														focus:outline-none focus:ring-0 focus:border-blue-600 peer"
// 											onChange={(e) =>
// 												handleFormPatientNoteChange(e, setNotesData, notesData)
// 											}
// 											value={notesData.remind}
// 											name="remind"
// 											placeholder=" "
// 											onKeyPress={(e) => {
// 												if (
// 													isNaN(String.fromCharCode(e.charCode)) ||
// 													e.target.value.length >= 10
// 												) {
// 													e.preventDefault();
// 												}
// 											}}
// 										/>
// 										<label
// 											htmlFor="remind"
// 											className="ml-[0.3rem]  absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform 
// 														-translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 
// 														peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
// 														peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
// 										>
// 											Remind in Days
// 										</label>
// 									</div>
// 								</div>
// 							)}
// 						</div>



// 						{notesData?.message !== null && (
// 							<div
// 								className="flex items-center justify-center fs-12"
// 								style={{ color: "red" }}
// 							>
// 								{notesData?.message}
// 							</div>
// 						)}

// 						<div className="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
// 							<div className="grid grid-cols-12 gap-4 md:gap-7 lg:gap-7 mx-auto">
// 								<div className="col-span-12">
// 									<button
// 										type="submit"
// 										onClick={() =>
// 											type === "Header_Add_Note"
// 												? (() => {
// 													if (!formData.patientName) {
// 														setErrorMessages({
// 															...errorMessages,
// 															patientName: "Please Select the Patient",
// 														});
// 													} else if (!selectedNoteOptions.label) {
// 														setNotesData({
// 															...notesData,
// 															message: "Please Select the Note",
// 														});
// 													} else {
// 														setNotesData({ ...notesData, message: "" });
// 														dispatch(
// 															savePatientNotes(
// 																formData?.patientName?.value,
// 																notesData,
// 																showToast,
// 																setShowToast,
// 																paginationNumber,
// 																location,
// 																showModal,
// 																setShowModal,
// 																queryStatus,
// 																querySearch,
// 																color,
// 																type
// 															)
// 														);
// 													}
// 												})()
// 												: submitPatientNote(
// 													selectedNoteOptions,
// 													setNotesData,
// 													notesData,
// 													patientProfileData,
// 													setShowToast,
// 													showToast,
// 													paginationNumber,
// 													location,
// 													showModal,
// 													setShowModal,
// 													dispatch,
// 													queryStatus,
// 													querySearch,
// 													color,
// 													type
// 												)
// 										}
// 										className="rubik-500 fs-16 h-[42px] text-white bg-blue-700 rounded focus:ring-transparent w-full text-sm px-5 py-2.5"
// 										style={{ position: "relative", overflow: "hidden" }}
// 									>
// 										{savePatientListResponse?.loading ? "Saving..." : "Save"}
// 									</button>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 		</>
// 	);
// };
// export default AddNotes;





import React, { useEffect, useState, useCallback, useMemo } from "react";

import { useCustomDispatch, useCustomLocation } from "../../hooks";

import {
	handleFormPatientNoteChange,
	handleRecurrenceChange,
} from "../../utils/data/handleFormDataChange";

import { hidePatientNoteModal } from "../../assets/js/custome";
import { ModalCloseIcon } from "../../assets/svg/icons";
import { useCustomPatientSelectors } from "../../services/selectors/patientSelectors";
import { customStyles } from "../../style";

import { PatientList } from "../../components/pharmacy/form/form";
import { fetchPatientNotesList } from "../../services/actions/patients/patientNotesList";
import { savePatientNotes } from "../../services/actions/patients/savePatientNote";
import { submitPatientNote } from "../../utils/validations/others";

import Select from "react-select";
import Axios from "../../networking/intraceptor";

import * as initial from "../../utils/constants/formInitialStates";


const AddNotes = ({
	setShowModal,
	showModal,
	patientProfileData,
	paginationNumber,
	showToast,
	setShowToast,
	queryStatus,
	querySearch,
	type,
}) => {
	const dispatch = useCustomDispatch();
	const location = useCustomLocation();

	const {
		savePatientListResponse,
		patientListNotesData,
		patientListNotesResponse,
	} = useCustomPatientSelectors();

	const [patientNotesData, setPatientNoteData] = useState([]);
	const [selectedNoteOptions, setSelectedNoteOptions] = useState([]);
	const [color, setColor] = useState('#FFFFFF')

	const [notesData, setNotesData] = useState(initial.initalPatientNotes);
	const [formData, setFormData] = useState(initial.initalTopHeaderAddNoteData);

	const [errorMessages, setErrorMessages] = useState(
		initial.initalTopHeaderAddNoteData
	);

	// Notify team states
	const [notifyTeam, setNotifyTeam] = useState(false);
	const [teamList, setTeamList] = useState([]);
	const [selectedTeam, setSelectedTeam] = useState([]);
	const [loadingTeam, setLoadingTeam] = useState(false);

	// Tab state
	const [activeTab, setActiveTab] = useState('patientNote');

	// Template form states
	const [templateForm, setTemplateForm] = useState({
		template_title: '',
		template: ''
	});
	const [templateColor, setTemplateColor] = useState('#FFFFFF');
	const [templateError, setTemplateError] = useState('');
	const [savingTemplate, setSavingTemplate] = useState(false);
	const [templatesList, setTemplatesList] = useState([]);
	const [loadingTemplates, setLoadingTemplates] = useState(false);
	const [editingTemplate, setEditingTemplate] = useState(null);
	const [deletingTemplateId, setDeletingTemplateId] = useState(null);

	// Template team notification states
	const [templateNotifyTeam, setTemplateNotifyTeam] = useState(false);
	const [selectedTemplateTeam, setSelectedTemplateTeam] = useState([]);

	const handleSelectChange = useCallback(async (selectedValues) => {
		setSelectedNoteOptions(selectedValues);
		setNotesData(prev => ({
			...prev,
			// Keep anything the user has already typed and place it below the
			// selected template instead of replacing the existing note.
			notes: prev.notes?.trim() && selectedValues?.data
				? `${selectedValues.data}\n\n${prev.notes}`
				: selectedValues?.data || prev.notes,
			selectedNoteOptions: selectedValues?.label,
		}));
		
		// Update note color if template has bg_color
		if (selectedValues?.bg_color) {
			setColor(selectedValues.bg_color);
		}
		
		// Handle team members if template has them
		// Priority: Use team_members array if available (from API), otherwise use team_member_ids
		if (selectedValues?.team_members && selectedValues.team_members.length > 0) {
			// Use team_members array if available (with id and name) - best option
			const matchedTeam = selectedValues.team_members.map(member => ({
				label: member.name,
				value: member.id
			}));
			setSelectedTeam(matchedTeam);
			setNotifyTeam(true);
		} else if (selectedValues?.team_member_ids && selectedValues.team_member_ids.length > 0) {
			// Fallback: Use team_member_ids and match with teamList
			// Ensure team list is loaded
			if (teamList.length === 0) {
				// Fetch team list first
				setLoadingTeam(true);
				try {
					const response = await Axios.post('/pharmacy-task/taskusers', {});
					if (response?.status === 200 && response?.data?.success) {
						const formattedTeam = response.data.data.map((user) => ({
							label: user.name,
							value: user.id,
						}));
						setTeamList(formattedTeam);
						// Match IDs with fetched team list
						const matchedTeam = formattedTeam.filter(user => 
							selectedValues.team_member_ids.includes(user.value)
						);
						setSelectedTeam(matchedTeam);
						setNotifyTeam(matchedTeam.length > 0);
					}
				} catch (error) {
					console.error('Error fetching team:', error);
				} finally {
					setLoadingTeam(false);
				}
			} else {
				// Team list already loaded, match IDs immediately
				const matchedTeam = teamList.filter(user => 
					selectedValues.team_member_ids.includes(user.value)
				);
				setSelectedTeam(matchedTeam);
				setNotifyTeam(matchedTeam.length > 0);
			}
		} else {
			// No team members in template, clear team selection
			setSelectedTeam([]);
			setNotifyTeam(false);
		}
	}, [teamList]);

	useEffect(() => {
		const notesData = patientListNotesData;
		const formattedNotesData = notesData?.map((value, index) => ({
			label: value.selectednoteoption,
			value: index,
			data: value.notes,
			bg_color: value.bg_color || value.color || null, // Include bg_color from template
			team_member_ids: value.team_member_ids || null, // Include team_member_ids from template
			team_members: value.team_members || null, // Include team_members array from template
		}));

		setPatientNoteData(formattedNotesData);
	}, [patientListNotesData]);

	const handlePetientNotesList = useCallback(() => {
		if (patientListNotesResponse?.data === null) {
			dispatch(fetchPatientNotesList());
		}
	}, [dispatch, patientListNotesResponse?.data]);

	const handleColorChange = (event) => {
		setColor(event.target.value);
	};

	// Fetch team when notify team checkbox is checked - memoized
	const fetchTaskTeam = useCallback(async () => {
		if (teamList.length > 0) return; // Don't fetch if already loaded
		
		setLoadingTeam(true);
		try {
			const response = await Axios.post('/pharmacy-task/taskusers', {});
			if (response?.status === 200 && response?.data?.success) {
				const formattedTeam = response.data.data.map((user) => ({
					label: user.name,
					value: user.id,
				}));
				setTeamList(formattedTeam);
			}
		} catch (error) {
			console.error('Error fetching team:', error);
		} finally {
			setLoadingTeam(false);
		}
	}, [teamList.length]);

	// Handle notify team checkbox change - memoized
	const handleNotifyTeamChange = useCallback((e) => {
		const isChecked = e.target.checked;
		setNotifyTeam(isChecked);
		if (isChecked) {
			fetchTaskTeam();
		} else {
			setSelectedTeam([]);
		}
	}, [fetchTaskTeam]);

	// Handle team selection change - memoized
	const handleTeamChange = useCallback((selectedValues) => {
		setSelectedTeam(selectedValues || []);
	}, []);

	// Handle template notify team checkbox change - memoized
	const handleTemplateNotifyTeamChange = useCallback((e) => {
		const isChecked = e.target.checked;
		setTemplateNotifyTeam(isChecked);
		if (isChecked) {
			fetchTaskTeam(); // Reuse the same team fetch function
		} else {
			setSelectedTemplateTeam([]);
		}
	}, [fetchTaskTeam]);

	// Handle template team selection change - memoized
	const handleTemplateTeamChange = useCallback((selectedValues) => {
		setSelectedTemplateTeam(selectedValues || []);
	}, []);

	// Handle template form change - memoized
	const handleTemplateFormChange = useCallback((e) => {
		const { name, value } = e.target;
		setTemplateForm(prev => ({
			...prev,
			[name]: value
		}));
		setTemplateError('');
	}, []);

	// Fetch templates list - memoized with useCallback
	const fetchTemplatesList = useCallback(async () => {
		setLoadingTemplates(true);
		try {
			const response = await Axios.get('pharmacy-patient-note-template');
			if (response?.status === 200 && response?.data?.success) {
				setTemplatesList(response.data.data || []);
			}
		} catch (error) {
			console.error('Error fetching templates:', error);
		} finally {
			setLoadingTemplates(false);
		}
	}, []);

	// Fetch templates when Template List tab is active
	useEffect(() => {
		if (activeTab === 'templateList') {
			fetchTemplatesList();
		}
	}, [activeTab, fetchTemplatesList]);

	// Handle edit template - memoized
	const handleEditTemplate = useCallback(async (template) => {
		setEditingTemplate(template.id);
		setTemplateForm({
			template_title: template.template_title,
			template: template.template
		});
		setTemplateColor(template.bg_color || template.color || '#FFFFFF');
		setTemplateError('');
		
		// Handle team members if they exist
		// Priority: Use team_members array if available (from API), otherwise use team_member_ids
		if (template.team_members && template.team_members.length > 0) {
			// Use team_members array if available (with id and name) - best option
			const matchedTeam = template.team_members.map(member => ({
				label: member.name,
				value: member.id
			}));
			setSelectedTemplateTeam(matchedTeam);
			setTemplateNotifyTeam(true);
		} else if (template.team_member_ids && template.team_member_ids.length > 0) {
			// Fallback: Use team_member_ids and match with teamList
			// Ensure team list is loaded
			if (teamList.length === 0) {
				// Fetch team list first
				setLoadingTeam(true);
				try {
					const response = await Axios.post('/pharmacy-task/taskusers', {});
					if (response?.status === 200 && response?.data?.success) {
						const formattedTeam = response.data.data.map((user) => ({
							label: user.name,
							value: user.id,
						}));
						setTeamList(formattedTeam);
						// Match IDs with fetched team list
						const matchedTeam = formattedTeam.filter(user => 
							template.team_member_ids.includes(user.value)
						);
						setSelectedTemplateTeam(matchedTeam);
						setTemplateNotifyTeam(matchedTeam.length > 0);
					}
				} catch (error) {
					console.error('Error fetching team:', error);
				} finally {
					setLoadingTeam(false);
				}
			} else {
				// Team list already loaded, match IDs immediately
				const matchedTeam = teamList.filter(user => 
					template.team_member_ids.includes(user.value)
				);
				setSelectedTemplateTeam(matchedTeam);
				setTemplateNotifyTeam(matchedTeam.length > 0);
			}
		} else {
			// No team members, reset
			setSelectedTemplateTeam([]);
			setTemplateNotifyTeam(false);
		}
		
		// Switch to Add Template tab
		setActiveTab('addTemplate');
	}, [teamList]);

	// Handle delete template - memoized
	const handleDeleteTemplate = useCallback(async (templateId) => {
		if (!window.confirm('Are you sure you want to delete this template?')) {
			return;
		}

		setDeletingTemplateId(templateId);
		try {
			const response = await Axios.delete(`pharmacy-patient-note-template/${templateId}`);
			
			if (response?.status === 200 && response?.data?.success) {
				// Show success message
				if (typeof setShowToast === 'function') {
					setShowToast(prev => ({
						...prev,
						patientNoteToast: true
					}));

					setTimeout(() => {
						setShowToast(prev => ({
							...prev,
							patientNoteToast: false
						}));
					}, 3000);
				}

				// Refresh templates list and patient notes list
				fetchTemplatesList();
				dispatch(fetchPatientNotesList());
			} else {
				alert(response?.data?.message || 'Failed to delete template');
			}
		} catch (error) {
			console.error('Error deleting template:', error);
			alert(error?.response?.data?.message || 'Failed to delete template. Please try again.');
		} finally {
			setDeletingTemplateId(null);
		}
	}, [fetchTemplatesList, dispatch, setShowToast]);

	// Save template
	const handleSaveTemplate = async () => {
		if (!templateForm.template_title.trim()) {
			setTemplateError('Template title is required');
			return;
		}
		if (!templateForm.template.trim()) {
			setTemplateError('Template description is required');
			return;
		}

		setSavingTemplate(true);
		setTemplateError('');

		try {
			let response;
			const teamMemberIds = selectedTemplateTeam.map(user => user.value);
			
			if (editingTemplate) {
				// Update existing template
				response = await Axios.put(`pharmacy-patient-note-template/${editingTemplate}`, {
					template_title: templateForm.template_title.trim(),
					template: templateForm.template.trim(),
					status: true,
					bg_color: templateColor,
					team_member_ids: teamMemberIds // Add team member IDs
				});
			} else {
				// Create new template
				response = await Axios.post('pharmacy-patient-note-template', {
					template_title: templateForm.template_title.trim(),
					template: templateForm.template.trim(),
					status: true,
					bg_color: templateColor,
					team_member_ids: teamMemberIds // Add team member IDs
				});
			}

			if (response?.status === 200 && response?.data?.success) {
				// Store editing state before resetting
				const wasEditing = editingTemplate !== null;
				
				// Reset form
				setTemplateForm({
					template_title: '',
					template: ''
				});
				setTemplateColor('#FFFFFF');
				setTemplateNotifyTeam(false); // Reset template notify team
				setSelectedTemplateTeam([]); // Reset selected template team
				setEditingTemplate(null);
				
				// Show success message
				if (typeof setShowToast === 'function') {
					setShowToast(prev => ({
						...prev,
						patientNoteToast: true
					}));

					setTimeout(() => {
						setShowToast(prev => ({
							...prev,
							patientNoteToast: false
						}));
					}, 3000);
				}

				// Refresh templates list and patient notes list
				fetchTemplatesList();
				dispatch(fetchPatientNotesList());

				// Navigate back to Template List tab after update
				if (wasEditing) {
					setActiveTab('templateList');
				}
			} else {
				setTemplateError(response?.data?.message || 'Failed to save template');
			}
		} catch (error) {
			console.error('Error saving template:', error);
			setTemplateError(error?.response?.data?.message || 'Failed to save template. Please try again.');
		} finally {
			setSavingTemplate(false);
		}
	};

	return (
		<>
			<div
				className="fixed inset-0 z-50 flex items-center justify-center w-full h-full bg-black/60 backdrop-blur-sm"
			>
				<div className="relative w-full max-w-2xl mx-4 max-h-[90vh] overflow-hidden overflow-y-auto commonscrollbarhide">
					<div className="relative bg-white rounded-2xl shadow-2xl dark:bg-gray-800 border border-gray-100 dark:border-gray-700">
						{/* Header */}
						<div className="flex items-center justify-between px-6 py-2 border-b border-gray-100 dark:border-gray-700 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-700 dark:to-gray-800 rounded-t-2xl">
							<div className="flex items-center space-x-2">
									<svg className="w-5 h-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
									</svg>
									<h3 className="text-xl font-bold text-gray-900 dark:text-white">
										Patient Note
									</h3>
							</div>
							<button
								onClick={() => hidePatientNoteModal(setShowModal, showModal)}
								type="button"
								className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-gray-300 rounded-full transition-all duration-200"
							>
								<ModalCloseIcon />
								<span className="sr-only">Close modal</span>
							</button>
						</div>

						{/* Tabs Navigation */}
						<div className="px-6 pt-4 pb-2">
							<ul className="inline-flex gap-1 bg-gray-200 p-1 rounded-xl">
								{useMemo(() => [
									{ id: 'patientNote', label: 'Patient Note' },
									{ id: 'templateList', label: 'Template List' },
									{ id: 'addTemplate', label: 'Add Template' }
								], []).map((tab) => (
									<li key={tab.id}>
										<button
											onClick={() => {
												setActiveTab(tab.id);
								// Reset template form when switching to Add Template tab (unless editing)
								if (tab.id === 'addTemplate' && !editingTemplate) {
									setTemplateForm({ template_title: '', template: '' });
									setTemplateColor('#FFFFFF');
									setTemplateError('');
									setTemplateNotifyTeam(false); // Reset notify team
									setSelectedTemplateTeam([]); // Reset selected team
								}
												// Fetch templates when switching to Template List tab
												if (tab.id === 'templateList') {
													fetchTemplatesList();
												}
												// Clear editing state when switching away from Add Template
												if (tab.id !== 'addTemplate') {
													setEditingTemplate(null);
													setTemplateNotifyTeam(false); // Reset notify team
													setSelectedTemplateTeam([]); // Reset selected team
												}
											}}
											className={`px-4 py-2 text-sm font-medium rounded-lg transition-all whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
												activeTab === tab.id
													? 'bg-white text-gray-900 shadow-md'
													: 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
											}`}
											aria-label={`Switch to ${tab.label} tab`}
										>
											{tab.label}
										</button>
									</li>
								))}
							</ul>
						</div>

						{/* Content */}
						<div className="px-6 py-2 space-y-2">
							{/* Patient Note Tab Content */}
							{activeTab === 'patientNote' && (
								<>
									{type === "Header_Add_Note" && (
										<div className="">
											
											<PatientList
												formData={formData}
												setFormData={setFormData}
												errorMessages={errorMessages}
												setErrorMessages={setErrorMessages}

											/>
										</div>
									)}

									{/* Note Options Selection */}
									<div className="space-y-2">
										<div className="relative" onClick={handlePetientNotesList}>
											
											<Select
												isClearable={false}
												options={patientNotesData}
												isSearchable
												value={selectedNoteOptions}
												onChange={handleSelectChange}
												className="basic-multi-select"
												classNamePrefix="react-select"
												styles={customStyles}
												placeholder="Choose a note template..."
												noOptionsMessage={() =>
													patientListNotesResponse?.loading
														? "Loading templates..."
														: "No templates available"
												}
											/>
										</div>

										{/* Notes Textarea */}
										<div className="space-y-1">
											
											<div className="relative">
												<textarea
													onChange={(e) =>
														handleFormPatientNoteChange(e, setNotesData, notesData)
													}
													value={notesData.notes}
													name="notes"
													className="w-full px-4 py-3 text-gray-900 bg-white border border-gray-300 focus:outline-none rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-400 dark:focus:border-blue-400 transition-all duration-200 resize-none"
													rows="6"
													placeholder="Enter your notes here..."
													id="cancellationNotes"
												></textarea>
											</div>
										</div>

										{/* Recurrence and Color Settings */}
										
										<div className="flex items-center gap-2 flex-wrap">
											<div className="flex items-center space-x-3  h-[45px] bg-gray-50 dark:bg-gray-900 rounded p-4 py-1 border border-gray-200 dark:border-gray-700">
												
												<input
													id="recurrence-checkbox"
													type="checkbox"
													onChange={(e) =>
														handleRecurrenceChange(e, setNotesData, notesData)
													}
													value={notesData.recurrence}
													className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-transparent focus:ring-offset-0 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
												/>
												<label
													htmlFor="recurrence-checkbox"
													className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300"
												>
													Enable Recurrence
												</label>
												
											</div>

											{/* Notify Team Checkbox */}
											<div className="flex items-center space-x-3  h-[45px] bg-gray-50 dark:bg-gray-900 rounded p-4 py-1 border border-gray-200 dark:border-gray-700">
												<input
													id="notify-team-checkbox"
													type="checkbox"
													checked={notifyTeam}
													onChange={handleNotifyTeamChange}
													className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-transparent focus:ring-offset-0 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
												/>
												<label
													htmlFor="notify-team-checkbox"
													className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300"
												>
													Notify Team
												</label>
											</div>
											
											<div className="flex items-center  space-x-3  h-[45px] bg-gray-50 dark:bg-gray-900 rounded p-4 py-1 border border-gray-200 dark:border-gray-700">
												<span className="text-sm text-gray-600 dark:text-gray-400">Note Color:</span>
												<div className="relative">
													<input
														type="color"
														value={color}
														onChange={handleColorChange}
														className="w-8 h-8 rounded bg-transparent border-0"
													/>
												</div>
											</div>
										</div>

										{/* Team Multi-Select Dropdown */}
										{notifyTeam && (
											<div className="space-y-1">
												<label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
													Select Team to Notify
												</label>
												<Select
													isMulti
													isClearable
													isSearchable
													options={teamList}
													value={selectedTeam}
													onChange={handleTeamChange}
													className="basic-multi-select"
													classNamePrefix="react-select"
													styles={customStyles}
													placeholder={loadingTeam ? "Loading team..." : "Select team..."}
													noOptionsMessage={() =>
														loadingTeam
															? "Loading team..."
															: "No team available"
													}
												/>
											</div>
										)}

										

										{/* Remind in Days Field */}
										{notesData?.recurrence === 1 && (
											<div className="bg-blue-50 dark:bg-blue-900/20 rounded p-4 py-2 border border-blue-200 dark:border-blue-800">
												<div className="space-y-1">
													<label className="block text-sm font-medium text-blue-700 dark:text-blue-300">
														Reminder Settings
													</label>
													<div className="relative">
														<input
															type="text"
															id="remind"
															className="block w-full px-4 py-3 text-sm text-gray-900 bg-white border border-blue-300 rounded focus:ring-1 focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-blue-600 dark:text-white dark:focus:ring-blue-400 dark:focus:border-blue-400 transition-all duration-200"
															onChange={(e) =>
																handleFormPatientNoteChange(e, setNotesData, notesData)
															}
															value={notesData.remind}
															name="remind"
															placeholder="Enter number of days"
															onKeyPress={(e) => {
																if (
																	isNaN(String.fromCharCode(e.charCode)) ||
																	e.target.value.length >= 10
																) {
																	e.preventDefault();
																}
															}}
														/>
														<div className="absolute inset-y-0 right-0 flex items-center pr-3">
															<span className="text-sm text-blue-600 dark:text-blue-400">days</span>
														</div>
													</div>
													<p className="text-xs text-blue-600 dark:text-blue-400">
														Set how many days in advance to remind about this note
													</p>
												</div>
											</div>
										)}
									</div>

									{/* Error Message */}
									{notesData?.message !== null && notesData?.message !== "" && (
										<div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded p-4 py-2 ">
											<div className="flex items-center">
												<svg className="w-5 h-5 text-red-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
												</svg>
												<span className="text-sm font-medium text-red-700 dark:text-red-400">
													{notesData?.message}
												</span>
											</div>
										</div>
									)}
								</>
							)}

							{/* Template List Tab Content */}
							{activeTab === 'templateList' && (
								<div className="space-y-4">
									<div className="flex items-center justify-end">
										<button
											onClick={fetchTemplatesList}
											disabled={loadingTemplates}
											className="px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded hover:bg-blue-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex items-center gap-1.5"
										>
											<svg className={`w-4 h-4 ${loadingTemplates ? 'animate-spin' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
											</svg>
											Refresh
										</button>
									</div>

									{loadingTemplates ? (
										<div className="flex items-center justify-center py-12">
											<svg className="animate-spin h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
												<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
												<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
											</svg>
										</div>
									) : templatesList.length > 0 ? (
										<div className="max-h-[500px] overflow-y-auto border border-gray-200 dark:border-gray-700 rounded-lg">
											<table className="w-full text-sm text-left">
												<thead className="bg-gray-50 dark:bg-gray-800 sticky top-0">
													<tr>
														<th className="px-4 py-3 font-semibold text-gray-700 dark:text-gray-300">Title</th>
														<th className="px-4 py-3 font-semibold text-gray-700 dark:text-gray-300">Template</th>
														<th className="px-4 py-3 font-semibold text-gray-700 dark:text-gray-300">Color</th>
														<th className="px-4 py-3 font-semibold text-gray-700 dark:text-gray-300 text-right">Actions</th>
													</tr>
												</thead>
												<tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
													{templatesList.map((template) => {
														const templateBgColor = template.bg_color || template.color || '#FFFFFF';
														return (
															<tr key={template.id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
																<td className="px-4 py-3 font-medium text-gray-900 dark:text-white">
																	{template.template_title}
																</td>
																<td className="px-4 py-3 text-gray-600 dark:text-gray-400">
																	{template.template}
																</td>
																<td className="px-4 py-3">
																	<div 
																		className="w-16 h-8 rounded border border-gray-300"
																		style={{ backgroundColor: templateBgColor }}
																		title={templateBgColor}
																	/>
																</td>
															<td className="px-4 py-3">
																<div className="flex items-center justify-end gap-2">
																	<button
																		onClick={() => handleEditTemplate(template)}
																		className="px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded hover:bg-blue-100 transition-all duration-200 flex items-center gap-1.5"
																		title="Edit template"
																	>
																		<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
																			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
																		</svg>
																		Edit
																	</button>
																	<button
																		onClick={() => handleDeleteTemplate(template.id)}
																		disabled={deletingTemplateId === template.id}
																		className="px-3 py-1.5 text-xs font-medium text-red-700 bg-red-50 border border-red-200 rounded hover:bg-red-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex items-center gap-1.5"
																		title="Delete template"
																	>
																		{deletingTemplateId === template.id ? (
																			<svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
																				<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
																				<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
																			</svg>
																		) : (
																			<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
																				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
																			</svg>
																		)}
																		Delete
																	</button>
																</div>
															</td>
														</tr>
														);
													})}
												</tbody>
											</table>
										</div>
									) : (
										<div className="text-center py-12 border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-800">
											<svg className="w-12 h-12 text-gray-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
											</svg>
											<p className="text-sm text-gray-500 dark:text-gray-400">No templates found</p>
										</div>
									)}
								</div>
							)}

							{/* Add Template Tab Content - Template Creation Form */}
							{activeTab === 'addTemplate' && (
								<div className="space-y-4">
									<div className="space-y-2">
										<label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
											Template Title <span className="text-red-500">*</span>
										</label>
										<input
											type="text"
											name="template_title"
											value={templateForm.template_title}
											onChange={handleTemplateFormChange}
											className="w-full px-4 py-3 text-sm text-gray-900 bg-white border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-400 dark:focus:border-blue-400 transition-all duration-200"
											placeholder="Enter template title..."
										/>
									</div>

									<div className="space-y-2">
										<label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
											Template Description <span className="text-red-500">*</span>
										</label>
										<textarea
											name="template"
											value={templateForm.template}
											onChange={handleTemplateFormChange}
											rows="8"
											className="w-full px-4 py-3 text-sm text-gray-900 bg-white border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-400 dark:focus:border-blue-400 transition-all duration-200 resize-none"
											placeholder="Enter template description..."
										/>
									</div>

									{/* Note Color */}
									<div className="grid grid-cols-3 gap-4">
									<div className="flex items-center space-x-3 h-[45px] bg-gray-50 dark:bg-gray-900 rounded p-4 py-1 border border-gray-200 dark:border-gray-700">
										<span className="text-sm text-gray-600 dark:text-gray-400">Note Color:</span>
										<div className="relative">
											<input
												type="color"
												value={templateColor}
												onChange={(e) => setTemplateColor(e.target.value)}
												className="w-8 h-8 rounded bg-transparent border-0"
											/>
										</div>
									</div>

									{/* Notify Team Checkbox for Template */}
									<div className="flex items-center space-x-3 h-[45px] bg-gray-50 dark:bg-gray-900 rounded p-4 py-1 border border-gray-200 dark:border-gray-700">
										<input
											id="template-notify-team-checkbox"
											type="checkbox"
											checked={templateNotifyTeam}
											onChange={handleTemplateNotifyTeamChange}
											className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-transparent focus:ring-offset-0 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
										/>
										<label
											htmlFor="template-notify-team-checkbox"
											className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300"
										>
											Notify Team
										</label>
									</div>
									</div>

									{/* Team Multi-Select Dropdown for Template */}
									{templateNotifyTeam && (
										<div className="space-y-1">
											<label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
												Select Team to Notify
											</label>
											<Select
												isMulti
												isClearable
												isSearchable
												options={teamList}
												value={selectedTemplateTeam}
												onChange={handleTemplateTeamChange}
												className="basic-multi-select"
												classNamePrefix="react-select"
												styles={customStyles}
												placeholder={loadingTeam ? "Loading team..." : "Select team..."}
												noOptionsMessage={() =>
													loadingTeam
														? "Loading team..."
														: "No team available"
												}
											/>
										</div>
									)}

									{/* Error Message */}
									{templateError && (
										<div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded p-4 py-2">
											<div className="flex items-center">
												<svg className="w-5 h-5 text-red-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
												</svg>
												<span className="text-sm font-medium text-red-700 dark:text-red-400">
													{templateError}
												</span>
											</div>
										</div>
									)}
								</div>
							)}
						</div>

						{/* Footer */}
						<div className="px-6 py-2 bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 rounded-b-2xl">
							<div className="flex items-center justify-end space-x-3">
								<button
									onClick={() => hidePatientNoteModal(setShowModal, showModal)}
									type="button"
									className="px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border  border-gray-300 rounded hover:bg-gray-50 focus:outline-none focus:ring-0 focus:ring-offset-0 focus:ring-blue-500 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600 transition-all duration-200"
								>
									Cancel
								</button>
								{activeTab === 'patientNote' && (
									<button
										type="submit"
										onClick={() =>
											type === "Header_Add_Note"
												? (() => {
														// if (!formData.patientName) {
														// 	setErrorMessages({
														// 		...errorMessages,
														// 		patientName: "Please Select the Patient",
														// 	});
														// } else 
														
														if (!selectedNoteOptions.label) {
															setNotesData({
																...notesData,
																message: "Please Select the Note",
															});
														} else {
															setNotesData({ ...notesData, message: "" });
															// Extract team member IDs from selected team
															const teamUserIds = selectedTeam.map(user => user.value);
															dispatch(
																savePatientNotes(
																	formData?.patientName?.value,
																	notesData,
																	showToast,
																	setShowToast,
																	paginationNumber,
																	location,
																	showModal,
																	setShowModal,
																	queryStatus,
																	querySearch,
																	color,
																	type,
																	notifyTeam,
																	teamUserIds
																)
															);
														}
													})()
												: submitPatientNote(
													selectedNoteOptions,
													setNotesData,
													notesData,
													patientProfileData,
													setShowToast,
													showToast,
													paginationNumber,
													location,
													showModal,
													setShowModal,
													dispatch,
													queryStatus,
													querySearch,
													color,
													type,
													notifyTeam,
													selectedTeam?.map(user => user?.value)
												)
										}
										className="px-6 py-2.5 text-sm font-medium text-white bg-gradient-to-r  from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 rounded focus:outline-none focus:ring-0 focus:ring-offset-0 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex items-center space-x-2"
										disabled={savePatientListResponse?.loading}
									>
										{savePatientListResponse?.loading ? (
											<>
												<svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
													<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
													<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
												</svg>
												<span>Saving...</span>
											</>
										) : (
											<>
												<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
												</svg>
												<span>Save Note</span>
											</>
										)}
									</button>
								)}
								{activeTab === 'addTemplate' && (
									<button
										type="button"
										onClick={handleSaveTemplate}
										className="px-6 py-2.5 text-sm font-medium text-white bg-gradient-to-r  from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 rounded focus:outline-none focus:ring-0 focus:ring-offset-0 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex items-center space-x-2"
										disabled={savingTemplate}
									>
										{savingTemplate ? (
											<>
												<svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
													<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
													<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
												</svg>
												<span>Saving...</span>
											</>
										) : (
											<>
												<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
												</svg>
												<span>{editingTemplate ? 'Update Template' : 'Save Template'}</span>
											</>
										)}
									</button>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default AddNotes;
